/* PDP da marca — porte do storefront Hydrogen. Sem dependências.
   Galeria (thumbs/main/swipe/dots/lightbox) · troca de variante · quantidade ·
   abas desktop · sticky bar (IntersectionObserver). O add-to-cart continua no
   <product-form> do Dawn (AJAX + cart drawer). */
(function () {
  'use strict';

  function brl(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    var int = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + int + ',' + v[1];
  }

  document.querySelectorAll('[data-sv-product]').forEach(function (root) {
    var variants, media, cfg;
    try {
      variants = JSON.parse(root.querySelector('[data-sv-variants]').textContent);
      media = JSON.parse(root.querySelector('[data-sv-media]').textContent);
      cfg = JSON.parse(root.querySelector('[data-sv-config]').textContent);
    } catch (e) {
      return;
    }
    var inst = cfg.installments || 8;
    var keep = cfg.pixKeep || 90;

    // ---- Buy-box refs
    var priceEl = root.querySelector('[data-sv-price]');
    var compareEl = root.querySelector('[data-sv-compare]');
    var pctEl = root.querySelector('[data-sv-pct]');
    var instEl = root.querySelector('[data-sv-installment]');
    var pixEl = root.querySelector('[data-sv-pix]');
    var skuWrap = root.querySelector('.svp-sku');
    var skuEl = root.querySelector('[data-sv-sku]');
    var stockEl = root.querySelector('[data-sv-stock]');
    var stockText = root.querySelector('[data-sv-stocktext]');
    var varIdEl = root.querySelector('[data-sv-varid]');
    var addBtn = root.querySelector('[data-sv-add]');
    var addLabel = root.querySelector('[data-sv-addlabel]');

    // ---- Sticky refs
    var stickyImg = root.querySelector('[data-sv-sticky-img]');
    var stickyPrice = root.querySelector('[data-sv-sticky-price]');
    var stickyAdd = root.querySelector('[data-sv-sticky-add]');
    var stickyLabel = root.querySelector('[data-sv-sticky-label]');

    // ========================================================= Gallery
    var gIndex = 0;
    var stageMedia = root.querySelector('[data-sv-stage-media]');

    // ---- Thumbs (desktop): fade + setinha quando há overflow; centra o ativo
    var thumbsWrap = root.querySelector('[data-sv-thumbs-wrap]');
    var thumbsEl = root.querySelector('[data-sv-thumbs]');
    var thumbsMore = root.querySelector('[data-sv-thumbs-more]');
    function updateThumbScroll() {
      if (!thumbsWrap || !thumbsEl) return;
      var top = thumbsEl.scrollTop;
      var max = thumbsEl.scrollHeight - thumbsEl.clientHeight;
      thumbsWrap.classList.toggle('can-scroll-up', top > 4);
      thumbsWrap.classList.toggle('can-scroll-down', top < max - 4);
    }
    function scrollActiveThumb() {
      if (!thumbsEl) return;
      var t = thumbsEl.querySelector('[data-sv-thumb].is-active');
      if (!t) return;
      var over = t.offsetTop - thumbsEl.scrollTop;
      if (over < 0) thumbsEl.scrollTop = t.offsetTop;
      else if (over + t.offsetHeight > thumbsEl.clientHeight) thumbsEl.scrollTop = t.offsetTop + t.offsetHeight - thumbsEl.clientHeight;
    }

    function renderStage(i) {
      if (!stageMedia || !media[i]) return;
      var m = media[i];
      if (m.type === 'video' && m.video) {
        stageMedia.innerHTML =
          '<video class="svp-mainmedia" controls playsinline preload="metadata"' +
          (m.poster ? ' poster="' + m.poster + '"' : '') +
          '><source src="' + m.video + '" type="video/mp4"></video>';
      } else {
        stageMedia.innerHTML =
          '<img id="sv-main-image" class="svp-mainmedia" src="' + m.full +
          '" alt="' + (m.alt || '').replace(/"/g, '&quot;') +
          '" width="1200" height="1200" loading="eager" decoding="async">';
      }
    }

    function setActive(i) {
      var len = media.length;
      if (!len) return;
      gIndex = (i + len) % len;
      renderStage(gIndex);
      root.querySelectorAll('[data-sv-thumb]').forEach(function (t) {
        var on = parseInt(t.dataset.index, 10) === gIndex;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-sv-dot]').forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.index, 10) === gIndex);
      });
      scrollActiveThumb();
      if (lbOpen) renderLightbox();
    }

    root.querySelectorAll('[data-sv-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.dataset.index, 10)); });
    });
    if (thumbsEl) {
      thumbsEl.addEventListener('scroll', updateThumbScroll, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(updateThumbScroll).observe(thumbsEl);
      window.addEventListener('load', updateThumbScroll);
      updateThumbScroll();
    }
    if (thumbsMore) thumbsMore.addEventListener('click', function () {
      thumbsEl.scrollBy({ top: Math.round(thumbsEl.clientHeight * 0.7), behavior: 'smooth' });
    });
    root.querySelectorAll('[data-sv-dot]').forEach(function (d) {
      d.addEventListener('click', function () { setActive(parseInt(d.dataset.index, 10)); });
    });
    var prevBtn = root.querySelector('[data-sv-prev]');
    var nextBtn = root.querySelector('[data-sv-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(gIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(gIndex + 1); });

    // Swipe (mobile)
    var mainEl = root.querySelector('[data-sv-main]');
    if (mainEl && mainEl.dataset.swipe === 'true') {
      var sx = 0, sy = 0, swiped = false;
      mainEl.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false;
      }, { passive: true });
      mainEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          swiped = true;
          setActive(gIndex + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
      // impede o zoom logo após um swipe
      mainEl.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
      }, true);
    }

    // ---- Lightbox
    var lb = root.querySelector('[data-sv-lightbox]');
    var lbStage = root.querySelector('[data-sv-lb-stage]');
    var lbOpen = false;
    function renderLightbox() {
      if (!lbStage || !media[gIndex]) return;
      var m = media[gIndex];
      if (m.type === 'video' && m.video) {
        lbStage.innerHTML =
          '<video controls playsinline autoplay' + (m.poster ? ' poster="' + m.poster + '"' : '') +
          '><source src="' + m.video + '" type="video/mp4"></video>';
      } else {
        lbStage.innerHTML = '<img src="' + m.zoom + '" alt="' +
          (m.alt || '').replace(/"/g, '&quot;') + '" decoding="async">';
      }
    }
    function openLightbox() {
      if (!lb) return;
      lbOpen = true;
      renderLightbox();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lb) return;
      lbOpen = false;
      lb.hidden = true;
      lbStage.innerHTML = '';
      document.body.style.overflow = '';
    }
    var zoomBtn = root.querySelector('[data-sv-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
    var lbClose = root.querySelector('[data-sv-lb-close]');
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    var lbPrev = root.querySelector('[data-sv-lb-prev]');
    var lbNext = root.querySelector('[data-sv-lb-next]');
    if (lbPrev) lbPrev.addEventListener('click', function () { setActive(gIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { setActive(gIndex + 1); });
    if (lb) {
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
    }
    document.addEventListener('keydown', function (e) {
      if (!lbOpen) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') setActive(gIndex - 1);
      else if (e.key === 'ArrowRight') setActive(gIndex + 1);
    });

    // ========================================================= Variants
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-sv-option]').forEach(function (grp) {
        var idx = parseInt(grp.dataset.optionIndex, 10);
        var checked = grp.querySelector('[data-sv-optinput]:checked');
        if (checked) opts[idx] = checked.value;
      });
      return opts;
    }

    function findVariant(opts, availableOnly) {
      return variants.find(function (variant) {
        return (!availableOnly || variant.available) && variant.options.every(function (o, i) {
          return opts[i] === undefined || opts[i] === o;
        });
      });
    }

    function selectVariant(variant) {
      root.querySelectorAll('[data-sv-option]').forEach(function (grp) {
        var oi = parseInt(grp.dataset.optionIndex, 10);
        grp.querySelectorAll('[data-sv-optinput]').forEach(function (input) {
          input.checked = input.value === variant.options[oi];
        });
      });
    }

    function paintOptionState() {
      var opts = selectedOptions();
      root.querySelectorAll('[data-sv-option]').forEach(function (grp) {
        var oi = parseInt(grp.dataset.optionIndex, 10);
        // rótulo da cor selecionada
        var selInput = grp.querySelector('[data-sv-optinput]:checked');
        var sel = grp.querySelector('[data-sv-optvalue]');
        if (sel && selInput) sel.textContent = selInput.value;

        grp.querySelectorAll('[data-sv-colorwrap], [data-sv-pillwrap]').forEach(function (wrap) {
          var input = wrap.querySelector('[data-sv-optinput]');
          if (!input) return;
          var on = input.checked;
          // selecionado
          wrap.classList.toggle('is-active', on);
          var sw = wrap.querySelector('.sv-swatch');
          if (sw) sw.classList.toggle('is-selected', on);
          var nm = wrap.querySelector('[data-sv-colorname]');
          if (nm) nm.classList.toggle('is-selected', on);
          // disponibilidade combinada
          var trial = opts.slice();
          trial[oi] = input.value;
          var available = !!findVariant(trial, true);
          input.disabled = !available;
          wrap.setAttribute('data-unavailable', available ? 'false' : 'true');
          wrap.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      });
    }

    function update(preferredInput) {
      var options = selectedOptions();
      var variant = findVariant(options, true);
      if (!variant && preferredInput) {
        options = [];
        options[parseInt(preferredInput.closest('[data-sv-option]').dataset.optionIndex, 10)] = preferredInput.value;
        variant = findVariant(options, true);
      }
      if (!variant) variant = findVariant([], true) || findVariant(options);
      paintOptionState();
      if (!variant) return;
      selectVariant(variant);
      paintOptionState();

      if (priceEl) priceEl.textContent = brl(variant.price);
      if (instEl) instEl.textContent = brl(Math.round(variant.price / inst));
      if (pixEl) pixEl.textContent = brl(Math.round((variant.price * keep) / 100));

      var onSale = variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = brl(variant.compare_at_price);
      }
      if (pctEl) {
        pctEl.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          pctEl.textContent = '-' + pct + '%';
        }
      }

      if (skuEl) skuEl.textContent = variant.sku || '';
      if (skuWrap) skuWrap.hidden = !variant.sku;

      if (varIdEl) varIdEl.value = variant.id;

      // Estoque + botão
      if (stockEl) stockEl.setAttribute('data-available', variant.available ? 'true' : 'false');
      if (stockText) stockText.textContent = variant.available ? 'Em estoque' : 'Esgotado';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (variant.available) addBtn.removeAttribute('aria-disabled');
        else addBtn.setAttribute('aria-disabled', 'true');
      }
      if (addLabel) addLabel.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';

      // Galeria — imagem da variante
      if (variant.media_index >= 0) setActive(variant.media_index);

      // Sticky bar
      if (stickyPrice) stickyPrice.textContent = brl(variant.price);
      if (stickyImg && variant.thumb) stickyImg.src = variant.thumb;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (stickyLabel) stickyLabel.textContent = variant.available ? 'Comprar' : 'Esgotado';

      // URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    root.querySelectorAll('[data-sv-optinput]').forEach(function (inp) {
      inp.addEventListener('change', function () { update(inp); });
    });

    // ========================================================= Quantity
    var qty = root.querySelector('[data-sv-qty]');
    if (qty) {
      var valEl = qty.querySelector('[data-sv-qty-value]');
      var hidden = root.querySelector('[data-sv-qty-input]');
      var minus = qty.querySelector('[data-sv-qty-minus]');
      var plus = qty.querySelector('[data-sv-qty-plus]');
      function setQty(n) {
        n = Math.max(1, n);
        if (valEl) valEl.textContent = n;
        if (hidden) hidden.value = n;
        if (minus) minus.disabled = n <= 1;
      }
      if (minus) minus.addEventListener('click', function () {
        setQty((parseInt(hidden.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        setQty((parseInt(hidden.value, 10) || 1) + 1);
      });
    }

    // ========================================================= Desktop tabs
    var tabsRoot = root.querySelector('[data-sv-tabs]');
    if (tabsRoot) {
      tabsRoot.querySelectorAll('[data-sv-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.dataset.svTab;
          tabsRoot.querySelectorAll('[data-sv-tab]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          tabsRoot.querySelectorAll('[data-sv-panel]').forEach(function (p) {
            p.hidden = p.dataset.svPanel !== id;
          });
        });
      });
    }

    // ========================================================= Sticky bar
    var sticky = root.querySelector('[data-sv-sticky]');
    var sentinel = root.querySelector('[data-sv-sentinel]');
    if (sticky && sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(sentinel);
    }
    if (stickyAdd && addBtn) {
      stickyAdd.addEventListener('click', function () {
        if (!stickyAdd.disabled) addBtn.click();
      });
    }

    // Estado inicial
    update();
  });
})();
